export default {
  title: 'Stats',
  ekrmTab: 'EKRM',
  referenceModelsTab: 'Reference Models',
  export: 'Export',
  headerModel: 'Model',
  headerDateCreated: 'Date Created',
  headerCreatedBy: 'Created By',
  headerReference: 'Reference',
  headerCountry: 'Country',
  headerReferenceId: 'Reference ID',
  headerCategory: 'Category',
  headerCustomModelsCount: 'Custom Models Count',
  headerCountLast90Days: 'Count Last 90 days'
}
